import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import styles from '../styles/configuration.module.scss';
import InputComponent from './inputComponent';

function StorageConfig({ service, changeConfigurations, intialConfigs, space }) {
    const { t } = useTranslation('configuration');

    const disks = ['ssd', 'hdd'];
    const protocols = ['s3', 'iscsi'];

    const [options, setOptions] = useState(intialConfigs);
    const [isHidden, setIsHidden] = useState(true);

    useEffect(() => {
        changeConfigurations(options);
    }, [options]);

    return (
        <>
            <div className={styles.service}>
                <div className={'flex ' + styles['service-title']}>
                    <img src={service.img} alt={t("serviceImageAlt")} />
                    <h5>{t(`${service.title}.title`)}</h5>
                </div>
                <p>{t(`${service.title.toLowerCase()}.description`)}</p>
                <div style={{ display: 'contents' }}>
                    <div className={'flex ' + styles.configs} onClick={() => setIsHidden(!isHidden)}>
                        <div className={styles['arrow-container']}>
                            <div className={`${styles['arrow-element']} ${isHidden ? '' : styles['rotate-forward']}`} />
                        </div>
                        <p className={'pointer ' + styles.title}>{t('config')}</p>
                    </div>
                    <div className={`${styles[isHidden ? 'hide' : 'visible']} ${styles['storage-options']}`}>
                        { disks.filter(disk => !(!space.hdd && disk === 'hdd')).map(disk => (
                        <div key={disk} className={'flex col ' + styles['storage-type']}>
                                <h5>{disk.toUpperCase()}</h5>
                            { protocols.map((option, key) => (
                                <InputComponent key={key}
                                                initial={options[disk][option]}
                                                label={`${service.title.toLowerCase()}.${option}`}
                                                free={space[disk].free - options[disk][option === 's3' ? 'iscsi' : 's3']}
                                                usable={space[disk].total}
                                                setSpace={newOption => setOptions(prevState => ({ ...prevState, [disk]: {
                                                    ...prevState[disk],
                                                    [option]: newOption
                                                }}))}
                                                available={true} /> ))}
                        </div>)) }
                    </div>
                </div>
            </div>
            <style jsx>{`
                select {
                    width: 74px;
                }
            `}</style>
        </>
    )
};

export default memo(StorageConfig);
